import { rem } from "polished";
import styled from "styled-components";
import media from "styled-media-query";

import { helpers, themes } from "styles";

import { Container as ContainerComponent } from "components";

import Logo from "assets/porto-seguro-smooth.svg";

export const Container = styled.div``;

export const Banner = {
  Wrapper: styled.div`
    position: relative;
    z-index: 10;

    width: 100%;

    ${media.greaterThan("large")`
      height: 30vh;
    
      display: flex;
      align-items: center;
    `}

    ${media.lessThan("large")`
      padding-top: 20px;
      padding-bottom: 70px;
    `}

    ${helpers.gradientWithPrimaryColor}
  `,

  Content: styled(ContainerComponent)`
    padding: 0 10px;

    display: flex;
    align-items: center;
    justify-content: space-between;
  `,

  Title: styled.h1`
    color: #fff;
    font-size: 6vw;

    ${media.greaterThan("medium")`
      font-size: 4vw;
    `}

    ${media.greaterThan("large")`
      font-size: 2.5vw;
    `}
  `,

  Logo: styled.img.attrs({
    src: Logo,
  })`
    width: 20vw;
    margin-top: auto;

    ${media.greaterThan("medium")`
      width: 10vw;
    `}
  `,
};

export const Content = styled(ContainerComponent)`
  position: relative;
  z-index: 11;

  margin-top: -40px;
  padding: 30px 25px;

  border-radius: 12px;
  background-color: #fff;

  ${media.greaterThan("large")`
    padding: 40px 50px;
  `}

  ${helpers.defaultBoxShadow}
`;

export const Text = styled.p`
  margin-bottom: 30px;

  line-height: 220%;
  font-size: ${rem("10px")};
  color: ${themes.text.higher};

  ${media.greaterThan("huge")`
    margin-bottom: 40px;

    font-size: ${rem("14px")};
  `}
`;
